import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';

import {
  Header,
  Page,
} from 'components';

function Error404View({ permission }) {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (<Page maxWidth="lg" title="403: Forbidden">

    <Header />

    <Box mt={2}>
      <Card>
        <CardContent>

          <Typography
            align="center"
            color="textPrimary"
            children="403: Access to this resource on the server is denied!"
            variant={mobileDevice ? 'h4' : 'h1'}
          />

          {process.env.NODE_ENV === 'development' && (<Box mt={6}>
            <Typography
              align="center"
              color="textPrimary"
              children={<>You don't have permission to <b>{permission}</b></>}
              variant="body2"
            />
          </Box>)}

          <Box mt={6} display="flex" justifyContent="center">
            <Button
              children="Back to home"
              color="secondary"
              component={RouterLink}
              to="/"
              variant="outlined"
            />
          </Box>

        </CardContent>
      </Card>
    </Box>

  </Page>);
}

Error404View.propTypes = {
  permission: PropTypes.string,
};

export default Error404View;
